export const SERVER_INTERACTION_PAGES_BLACK_LIST = [
	'/admin',
	'/oauth2/redirect'
]
